import { createColumnHelper } from "@tanstack/react-table";
import { Link } from "@tanstack/react-router";

import { DataTableColumnHeader, DateCell, EmptyValue } from "@/components/data-table";
import type { ListResponse } from "@/types/lists.types";
import { getListTypeInfo } from "../lists/constants/list-types";

const columnHelper = createColumnHelper<ListResponse>();

export const featuredColumns = [
  columnHelper.accessor("listName", {
    header: ({ column }) => <DataTableColumnHeader column={column} title="List" />,
    cell: (info) => (
      <Link to="/dashboard/lists/detail/$listId" params={{ listId: info.row.original.id }} className="font-semibold text-foreground hover:text-brand">
        {info.getValue()}
      </Link>
    ),
  }),
  columnHelper.accessor("creatorName", {
    header: ({ column }) => <DataTableColumnHeader column={column} title="Created by" />,
    cell: (info) => (info.getValue() ? <span className="text-foreground">{info.getValue()}</span> : <EmptyValue />),
  }),
  columnHelper.accessor("listType", {
    header: "Type",
    enableSorting: false,
    cell: (info) => <span className="text-muted-foreground">{getListTypeInfo(info.getValue()).label}</span>,
  }),
  columnHelper.accessor("itemCount", {
    header: ({ column }) => <DataTableColumnHeader column={column} title="Places" align="right" />,
    cell: (info) => info.getValue(),
    meta: { align: "right" },
  }),
  columnHelper.accessor("createdAt", {
    header: ({ column }) => <DataTableColumnHeader column={column} title="Created" />,
    cell: (info) => <DateCell date={info.getValue()} />,
    sortingFn: "datetime",
  }),
];
